let categoriesConst = [
    {
        categoryCode: 1,
        categoryValue: 'All'
    },{
        categoryCode: 2,
        categoryValue: 'Crushes'
    },{
        categoryCode: 3,
        categoryValue: 'Restaurants'
    },{
        categoryCode: 4,
        categoryValue: 'Professors'
    },{
        categoryCode: 5,
        categoryValue: 'Raccoons'
    },{
        categoryCode: 6,
        categoryValue: 'SFSS'
    },{
        categoryCode: 7,
        categoryValue: 'Life'
    },{
        categoryCode: 8,
        categoryValue: 'Others'
    }
]

export default categoriesConst